
<div class="white-bg no-padding no-margin">
  <mat-card>
    <div style="text-align: center; margin-top: 1%;">
      <span class="title-header">Training </span>
    </div>
    <div style="text-align: center;margin-top: 1%;display: flex; flex-direction: column; font-size: x-large;font-weight: bolder;font-size: 28px;padding: 3%;">
      <span class="title-header" style="height: 50px;">Hello  {{username | aesDecrypt}} </span>
      <span class="title-header"> </span>
      <span class="title-Subheader">Click Start to begin </span>
      <span class="title-header">{{training}} </span>
    </div>
    <div style="width: 100%;   display: flex;flex-direction: row;justify-content:center;">
      <a class="button button--primary" (click)="StartTraining_()" >
        <span class="button__text">Start</span></a>
    </div>
  </mat-card>
</div>
